import React, {useState} from "react";
import languageLookup from './availableLanguages';
import { Grid, Dialog, DialogContent, DialogContentText, TextField, IconButton, Button, Select, DialogActions, Tooltip  } from '@material-ui/core';
import { Delete, Translate  } from '@material-ui/icons';



const TranslationEditor = ({ id, i18, name, text, disabled, updateTranslation }) => {
  const objectTranslations = i18 && Object.keys(i18).length ? Object.keys(i18).map(k => { return {language: k, value: i18[k]}}) : [];

  const [translationDialog, setTranslationDialog] = useState({translations:objectTranslations, open:false, changed:false, name, text});

  const currentLanguages = objectTranslations.map(d => d.language);
  const availableLanguages = Object.keys(languageLookup).filter(k => k !== "default" && !currentLanguages.includes(k)).map(k => { return {code:k, name: languageLookup[k]}});

  const newTranslation = () => { 
    const defaultLanguage = navigator.language && navigator.language.includes("-") ? navigator.language.split("-")[0] : "en";
    translationDialog.translations.push({language:defaultLanguage, value:""})
    setTranslationDialog({...translationDialog, changed:true});
  }
  const onChangeLanguage = (e, variable, index) => {
    translationDialog.translations[index][variable] = e.currentTarget.value;
    setTranslationDialog({...translationDialog, changed:true});
  }
  const onDeleteClick = (index) => {
    translationDialog.translations = translationDialog.translations.filter((c, i) => i !== index);
    setTranslationDialog({...translationDialog, changed:true});
  }
  const openDialog = () => setTranslationDialog({...translationDialog, translations:objectTranslations, open:true, changed:false})
  const closeDialog = () => setTranslationDialog({...translationDialog, open:false});
  const apply = () => {
    const i18 = {};
    translationDialog.translations.forEach(t => {
      i18[t.language] = t.value;
    })
    updateTranslation(i18);
    closeDialog();
  }

  const getTranslateButton = () => {
    const translateText = i18 ? `(${Object.keys(i18).length})` : "(0)";
    const translateVariant = i18 && Object.keys(i18).length ? "contained" : "outlined";
    const translateTooltip = i18 && Object.keys(i18).length ? "Click to configure translations (view, add, edit, delete)" : "Click to add new translation";
    return <Tooltip key={id + "-translate-button"} title={translateTooltip} className="mr-2">
      <Button disabled={disabled} component="span" onClick={openDialog} key={"translateButton-" + name} variant={translateVariant} color="secondary" className="mr-2"><Translate />{translateText}</Button>
    </Tooltip>
  }


  const translationRowRender = (translation, index, availableLanguages) => {
    const editor = <TextField value={ translation.value } onChange={(e) => onChangeLanguage(e, "value", index)} type="text" fullWidth variant="outlined" key={"value-editor-"+index} />
    const currentlySelectedLanguage = translation.language ? languageLookup[translation.language] : "Select";
    const languageSelector = <Select native type="timezone" value={translation.language} onChange={(e) => onChangeLanguage(e, "language", index)}>
          {translation.language && <option name={translation.language} type={"timezone"} value={translation.language} key="currentlySelected">{currentlySelectedLanguage}</option>}
          {availableLanguages.map(language => (
              <option key={"select-" + language.code} name={language.code} type="text" value={language.code}>
                {language.name}
              </option>
          ))}
          </Select>
    return (
      <Grid container spacing={2} direction="row" alignItems="center" key={"condition-item-row-"+index}>
        <Grid item xs={1}>
          <IconButton disabled={disabled} id={"condition-item-icon-button-"+index} onClick={() => onDeleteClick(index)} aria-label="Delete this item">
            <Delete id={"condition-item-delete-"+index}/>
          </IconButton>
        </Grid>
        <Grid item xs={3}>
          {languageSelector}
        </Grid>
        <Grid item xs={5}>
          {editor}
        </Grid>
      </Grid>
    )
  }

  if(!translationDialog.open || disabled) return getTranslateButton();

  return [
        getTranslateButton(),
        <Dialog open={translationDialog.open} onClose={closeDialog} fullWidth={true} maxWidth="md" key={"dialog-editor-" + id}>
          <DialogContent>
            <h5 className="card-title font-weight-bold font-size-md">{`Currently Configured Translation for (${name})`}</h5>
            <DialogContentText> <strong>Default value:</strong> { text } </DialogContentText>
            { translationDialog.translations.map((t, i) => translationRowRender(t, i, availableLanguages))}
          </DialogContent>
          <DialogActions>
            <Grid container spacing={2} direction="row" alignItems="center" justifyContent="space-between">
              <Grid item >
                <Button onClick={newTranslation} size="medium" className="ml-3" variant="contained" color="primary">Add Translation</Button>
              </Grid>
              <Grid item className="mt-3 mb-3">
                <Button onClick={() => apply()} disabled={ translationDialog.changed ? false : true } size="medium" variant="contained" color="primary">Apply Changes</Button>
                <Button onClick={closeDialog} size="medium" variant="outlined" className="ml-3 mr-3" color="primary">Cancel</Button>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>]
}
  
TranslationEditor.defaultProps = {
  text:"Current Default Value",
  i18: null,
  name: "Default",
  disabled: true, 
  updateTranslation: () => console.log("Default updateTranslation")
};

export default TranslationEditor;